export const RECEIVED_TRIVIAS = "RECEIVED_TRIVIAS";
export const RECEIVED_MORE_TRIVIAS = "RECEIVED_MORE_TRIVIAS";
export const FETCHING_TRIVIAS = "FETCHING_TRIVIAS";
export const FETCHING_MORE_TRIVIAS = "FETCHING_MORE_TRIVIAS";
export const CREATED_TRIVIA = "CREATED_TRIVIA";
export const UPDATED_TRIVIA = "UPDATED_TRIVIA";
export const DELETED_TRIVIA = "DELETED_TRIVIA";
export const UPDATED_CATEGORIES = "UPDATED_CATEGORIES";
export const UPDATING_TRIVIA = "UPDATING_TRIVIA";
